import styled from 'styled-components';
import { devices } from 'styles/devices';

export const WhiteWrapper = styled.div`
   max-width: 960px;
   padding: 20px;
   margin: 0 auto;

   ${devices.tabletXL} {
      max-width: 1100px;
   }

   ${devices.desktop} {
      max-width: 1200px;
   }

   ${devices.desktopHD} {
      max-width: 1440px;
   }

   ${devices.desktopFHD} {
      max-width: 1640px;
      padding: 0;
   }
`;
